import { getYear, startOfMonth, subMonths } from 'date-fns'
import { formatDateClient, formatDateServer } from './formatDate'
import { DATE_MONTH_YEAR } from './unicodeDateFormat'

const generateMonths = () => {
  const FIRST_YEAR_FOR_UPLOAD = 2023
  let currentMonth = startOfMonth(new Date())
  const monthsArray = []

  while (getYear(currentMonth) >= FIRST_YEAR_FOR_UPLOAD) {
    monthsArray.push({
      id: formatDateServer(currentMonth),
      label: formatDateClient(currentMonth, DATE_MONTH_YEAR),
    })

    currentMonth = subMonths(currentMonth, 1)
  }

  return monthsArray
}

export const monthsOptions = generateMonths()
